export default function CookiePolicy() {
	return (
		<iframe
			src="https://www.hemiteams.ai/cookie-policy"
			title="Cookie Policy"
			className="w-full h-full aspect-square"
		/>
	);
}
